import React from 'react';
import { StaticImageData } from 'next/image';
import { getSrc } from '~app/helpers/assetLoading';

// Simple Image Component props
type ImageComponentProps = {
  src: string | StaticImageData;
  alt: string;
  className: string;
};
const ImageComponent = ({ src, alt, className }: ImageComponentProps): JSX.Element => (
  <img src={getSrc(src)} alt={alt} className={className} />
);

export default ImageComponent;
